import { payments } from '../../config/stripe/constants';
import { CheckoutSession } from '../../config/stripe/types';

export const createCheckoutSession = async (
  priceId: string,
  options: {
    successUrl: string;
    cancelUrl: string;
  }
): Promise<CheckoutSession> => {
  const session = await payments.checkout({
    price: priceId,
    success_url: window.location.origin + options.successUrl,
    cancel_url: window.location.origin + options.cancelUrl,
    collect_shipping_address: false,
  });

  return session;
};